export enum PrivilegesEnum {
    /**
     * Возможность агента создавать лида без ИНН, ОГРН и наименования организации
     */
    CREATE_LEAD_WITH_INCOMPLETE_DATA = 'CREATE_LEAD_WITH_INCOMPLETE_DATA',
    /**
     * Возможность агента видеть статус лида
     */
    CAN_SEE_LEAD_STATUS = 'CAN_SEE_LEAD_STATUS',
}
